module.exports = __webpack_public_path__ + "img/top-left.57298883.jpg";